// extracted by mini-css-extract-plugin
export var hidden = "_sd-0";